<template>
  <div style="margin: 0.2rem; padding: 1.2rem; height: 99.5vh; cursor: auto;" class="bg-modal" @click.stop>

    <div class="personnalizationGrid">
      <!-- Online Reference -->
      <div style="grid-column: left">
        <showReference/>
      </div>

      <!-- Right -->
      <div style="grid-column: right">
        <referenceSheet/>
      </div>
    </div>

  </div>
</template>



<script setup>
import showReference from './showReference.vue'
import referenceSheet from './referenceSheet.vue'

import { onMounted } from 'vue'
import { useUiStore } from '@/stores/ui'
import { getSearchEnginePath, getDefaultSearchEngine }  from '@/functions/externalReference'
import { createReferenceSheetTitle } from "@/functions/resultSuggestion.js"
import { useCurrentEntryStore } from '@/stores/currentEntry'
const currentEntryStore = useCurrentEntryStore()
const uiStore = useUiStore()


function clearRefSheet() {
  uiStore.setReferenceSearchKewords("")
  uiStore.setReferenceIFramePath("")
  uiStore.setReferenceFile(null)
  uiStore.setCurrRefSheet(null)
}

function setDefaults() {
  const currExpr = getCurrExpression()
  const referenceExpr = getReferenceExpr(currExpr)
  const currRefSheet = uiStore.currRefSheet || referenceExpr?.refSheet || null
  uiStore.setCurrRefSheet(currRefSheet)

  //Set 1.column
  if (currRefSheet?.referenceFiles?.length) {
    uiStore.setReferenceIFramePath(null)
    uiStore.setReferenceFile(currRefSheet.referenceFiles[0])
    const keywords = createReferenceSheetTitle(currRefSheet)
    uiStore.setReferenceSearchKewords(keywords)
  } else if (currRefSheet?.externalLinks?.length) {
    uiStore.setReferenceFile(null)
    uiStore.setReferenceIFramePath(currRefSheet.externalLinks[0].link)
    const keywords = createReferenceSheetTitle(currRefSheet)
    uiStore.setReferenceSearchKewords(keywords)
  } else if (currRefSheet) {
    uiStore.setReferenceFile(null)
    const searchEngine = getDefaultSearchEngine(referenceExpr)
    const keywords = createReferenceSheetTitle(currRefSheet) || referenceExpr.originalText
    const path = getSearchEnginePath(searchEngine, keywords)
    uiStore.setReferenceIFramePath(path)
    uiStore.setReferenceSearchKewords(keywords)
  } else if (currExpr) {
    uiStore.setReferenceFile(null)
    const searchEngine = getDefaultSearchEngine(currExpr)
    const keywords = currExpr.originalText
    const path = getSearchEnginePath(searchEngine, keywords)
    uiStore.setReferenceIFramePath(path)
    uiStore.setReferenceSearchKewords(keywords)
  } else {
    uiStore.setReferenceFile(null)
    uiStore.setReferenceIFramePath(null)
    uiStore.setReferenceSearchKewords("")
  }
}

function getCurrExpression() {
  const dashBoardExpr = uiStore.dashBoardItem
  const assessmentExpr = currentEntryStore.currentCcl?.assessmentExpr
  const expr_cclExpr = currentEntryStore.currentResult?.expression
  return dashBoardExpr || assessmentExpr || expr_cclExpr || null
}

function getReferenceExpr(currExpr) {
  if (!currExpr) return null;
  if (["ResultDocument"].includes(currExpr.expressionType)) return null;
  const referenceExpressions = currentEntryStore.currCclSuggestionsFromResults?.expressions
  if (!referenceExpressions) return null;

  const assessmentRef = currentEntryStore.currentCcl?.assessmentExpr ? referenceExpressions[0] : null

  const referenceExpr = assessmentRef                                                                                           //Assessment expression
    || referenceExpressions.find(refExpr => refExpr.expressionId === currExpr.expressionId)                                     //Selected current expr
    || referenceExpressions.find(refExpr => refExpr.refSheet?.referenceFiles.length || refExpr.refSheet?.externalLinks.length)    //Take first expr with references (except if assessement expression)
    || referenceExpressions[0]                                                                                                  //Take first expr (without references)
  return referenceExpr
}

onMounted(() => {
  setDefaults()
})

</script>



<style scoped>
.personnalizationGrid {
  display: grid;
  grid-template-columns:
    [left] 2.1fr
    [empty] 8.0rem
    [right] 1.4fr
    [empty] 0.4rem
    ;
}
</style>